import React from 'react'
import { CommonBlock } from './CommonBlock'
import {
  PaperBlock,
  PaperQuestion,
  QuestionTypeEnum,
} from 'packages/sdks-next/growp'
import { ProductAnswer } from '../Answers/ProductAnswer'

export const RenderQuestionBlock: React.FC<{
  mainQuestion: PaperQuestion
  block: PaperBlock
  currentNum?: number
}> = ({ mainQuestion, block, currentNum }) => {
  switch (mainQuestion.type) {
    case QuestionTypeEnum.SingleChoice:
    case QuestionTypeEnum.MultipleChoice:
    case QuestionTypeEnum.ShortAnswer:
    case QuestionTypeEnum.FillInBlank: {
      return (
        <CommonBlock
          mainQuestion={mainQuestion}
          block={block}
          currentNum={currentNum}
        />
      )
    }
    case QuestionTypeEnum.Product: {
      return (
        <ProductAnswer
          block={block}
          mainQuestion={mainQuestion}
        />
      )
    }
    default: {
      return <>未知题型</>
    }
  }
}
